export const EMPTY_STATE_CAPTION = "Operations will appear here as they are executed.";
export const FILTERS_ORDER_SETTINGS_KEY = "intentProjectOperationLogFiltersOrder";
